const cn = {
    language: '简体中文',

    menu: {
        home: '首页',
        service: '产品与服务 ',
        product: '产品服务介绍',
        products: '资产管理工具',
        solution: ' 解决方案',
        message: '新闻资讯',
        developer: '开发者平台',
        browser: '区块浏览器',
        aboutUs: '关于我们',
        lang: '中/EN'
    },

    home: {
        slider1: {
            title: '恒为信息科技',
            description: '专注于区块链技术开发与产品创新 '
        },
        slider2: {
            title: '恒为信息科技',
            description: '提供专业的行业区块链整体解决方案 '
        },
        slider3: {
            title: '恒为区块链',
            description: '为应用提供高效稳定的区块链服务 '
        },

        part2: {
            head: '恒为链',
            desc: '恒为链提供专业、丰富的区块链功能',
            title1: '资产数字化',
            text1: '支持NFToken的发行，实现不同类型资产的数字化。',
            title2: '数据上链',
            text2: '不仅支持文字的上链，还融合IPFS实现文件的上链存储。',
            title3: '智能合约',
            text3: '合约编写、部署、执行简单，执行过程可跟踪。',
            title4: '跨链服务',
            text4: '实现恒为链与其他区块链之间价值和信息的互通。',

        },
        part3: {
            head: '服务内容',
            desc: '提供从方案咨询到应用搭建的全套服务',
            title1: '解决方案',
            description1: '为企业提供从方案咨询到应用搭建落地的整套行业解决方案。',
            text11: '区块链融合方案咨询',
            text12: '区块链平台服务搭建',
            text13: '区块链应用设计实现',
            text14: '智能合约编写与部署',
            text15: '区块链平台服务运维',
            title2: '区块链服务',
            description2: '为有上链需求的用户提供低门槛、低成本的区块链服务。',
            text21: '区块链数据存证服务',
            text22: '链上数据查询验证服务',
            text23: '数字资产管理服务',
            text24: '智能合约服务',
            title3: '开发者支持',
            description3: '为开发者提供开发区块链应用所需的基础设施和文档帮助。',
            text31: '开发者基础设施',
            text32: '开发文档支持',
        },
        part4: {
            head: '解决方案',
            desc: '我们拥有丰富的行业区块链应用落地经验',
            title1: '供应链金融',
            text1: '利用区块链公开透明、不可篡改，通证可流通的特点服务于供应链金融。',
            title2: '防伪溯源',
            text2: '利用区块链交易透明、可追溯、不可篡改的特点，实现对商品的防伪溯源。',
            title3: '物联网',
            text3: '利用恒为链高并发和支持文件上链的特点，实现物联网设备的数据上链。',
            title4: '医疗',
            text4: '利用恒为链并发高、确认快、稳定性好的特点支持医疗行业的区块链应用。',
            a: '查看解决方案',
        },
        part5: {
            tit: '合作伙伴',
            title1: '新希望集团',
            title2: '金中微',
            title3: '哲勤科技',
            title4: '曼荼罗',
            title5: '南京大学',
            title6: '中国电信',
            title7: '中兴',
        },
    },

    service: {

        part1: {

            tit: '恒为区块链',
            text: '自主研发的先进可控区块链平台 ',

        },
        part2: {
            tit: '技术特点',
            text: '具有优越性能的区块链平台',
            tit1: '高性能',
            text1: '自主研发的HCP共识算法性能达到5000+TPS。',
            tit2: '安全',
            text2: '非对称加密算法和多种安全机制确保资产和交易安全。',
            tit3: '稳定',
            text3: '节点监测系统和容错机制保障恒为链服务稳定。',
            tit4: '可扩展',
            text4: '模块化设计实现加密算法和各类功能的模块化配置。',

        },
        part3: {
            tit: '核心底层平台',
            text: '自主研发的先进区块链底层平台',
            tit1: '共识机制',
            text1: '基于PBFT自主研发的HCP共识算法，性能较高。',
            tit2: '加密算法',
            text2: '支持国际标准/国密SM2标准椭圆曲线加密算法。',
            tit3: '智能合约',
            text3: '采用LUA虚拟机，高效易用，合约执行日志可查询。',
            tit4: '数据上链',
            text4: '根据数据规模，提供文字和IPFS两种数据上链方案。',
            tit5: '资产数字化',
            text5: '根据ERC721标准，实现NFToken非同质化数字资产。',
            tit6: '批量转账',
            text6: '支持原子级的单账号高效批量转账功能。',
            tit7: '去中心化交易',
            text7: '支持恒为链通证间的去中心化撮合交易。',
            tit8: '跨链服务',
            text8: '实现恒为链与其它区块链之间价值与信息的高效互通。',
        },
        part4: {
            tit: '赋能服务平台',
            text: '为应用接入提供全面的区块链服务平台',
            tit1: 'API',
            text1: '丰富的API能够方便地与应用系统对接，提供区块链基础服务。',
            tit2: '资产数字化平台',
            text2: '便捷地发行Token和NFToken，服务于有资产数字化需求的应用。 ',
            tit3: '区块链浏览器',
            text3: '恒为链账本信息查询工具，为恒为链上的应用提供交易验证的平台。',
            tit4: '运维管理平台',
            text4: '实时监测恒为链节点的运行状态，保障恒为链能够提供稳定的服务。',
        },
        part5: {
            tit: '节点运行状态',
            l11: '服务上线时间：',
            l12: '查看运行状态',
            day: '天',
            l21: '服务已运行',
            l22: '节点数量',
            l23: '区块高度',
            l24: '交易总量',
        }
    },

    solution: {

        head: {
            tit: '区块链解决方案供应商 ',
            text: '提供方案咨询到应用搭建落地的整套行业解决方案 ',
        },
        center: {
            show1: '资产数字化',
            show2: '防伪溯源',
            show3: '数据共享',
            show4: '可信存证',
            tit1: '方案简介',
            tit2: '应用案例',
            partner: '合作方',
            time: '上线时间',
            tit3: '产品简介',
            tit4: '产品界面',
        },
        part1: {
            text1: '经过数字化的资产，可拆分后进行交易，降低了资产交易的门槛和复杂度，提高了资产的流动性和交易效率。资产交易的过程也是资产在链上流转存证的过程，公开透明的流转记录和可信的存证记录，能够有效地避免资产交易过程中垄断和虚假交易的现象。',
            label: '物博通',
            partner: '2018世界物联网博览会',
            time: '2018年9月',
            text2: '物博通是以2018世界物联网博览会为背景，通过区块链来记录展商与观众间互动，传递价值的小程序。程序主要实现了展商和观众的名片互换、礼品兑换和大会推广等功能。通过区块链，展商以公开透明的方式来获取观众的名片信息和发放礼品。观众以名片互换的方式来获取积分和兑换礼品。展商和观众之间的互动完全透明，避免了活动奖品摆设、内定中奖的现象。',
        },
        part2: {
            text1: '基于区块链数据不可篡改和可追溯的特性，将商品从原料到成品，从生产到流通的各个状态和作业环节上链。一物一码，实现终端消费者对商品的全链条溯源，追溯问题商品的源头，真正做到有责可追，追责有据。结合物联网还可实现信息的自动上链，节省人力，数据更具公信力。',
            label: '呈信农产品溯源平台',
            partner: '呈信区块链科技（云南）有限责任公司',
            time: '2019年6月',
            text2: '呈信农产品溯源平台旨在建立优质农产品溯源体系，帮助地方优质农产品品牌提档升级。平台利用区块链技术信息透明，不可篡改的特点，结合物联网技术，将农业产业的种植养殖、种苗肥料、环境监控、生产日记、采摘甄选、包装物流、销售渠道、原产地追溯等相关信息记录在链上，提升企业质量安全可信度，降低消费者维权监管成本和难度。',
        },
        part3: {
            text1: '通过区块链技术可追溯和不可篡改的特点实现数据的访问授权上链，能够有效解决数据在跨机构多部门间共享过程中的数据确权、数据共享权限控制、共享数据防篡改和数据使用监管方面的问题。区块链可信数据交换环境的建立，大大提高了数据的安全性和数据共享交换的效率。',
            label: '基于区块链的政务数据共享平台',
            partner: '无锡市新吴区科信局',
            time: '2017年11月',
            text2: '无锡市新吴区各政府部门间独立的数据限制了各政府部门服务能力的提升，政务数据的共享又存在着诸多法律、监管、隐私和安全方面的问题。通过区块链技术实现各部门间的数据交换，各部门既是数据的提供方，也是数据的需求方，通过区块链实现数据的授权访问，能够高效实现数据所属权的认定，使用权的监管，正确性和安全性的保障，大大提高了政府数据的利用率，让数据发挥出更大的价值。',
        },
        part4: {
            text1: '基于区块链数据不可篡改，多方参与共识的特性，可被用于电子存证领域。经过多方存证的信息，数据安全、防篡改、永久保存、可信度强，无需第三方机构出具证明，可被视为直接的证据。恒为区块链集成IPFS实现了文件的上链，扩展了存证的种类，文件的 IPFS Hash 被记录在恒为链上无法篡改。',
            label: '智能工厂大数据平台',
            partner: '上海新增鼎数据科技有限公司',
            time: '2018年8月',
            text2: '新增鼎数据利用物联网设备实现工厂无关化的数据采集。基于大数据与人工智能技术进行数据计算、数据建模、行业AI分析，通过区块链技术实现核心数据计算结果的多方存证，利用可视化技术和工具进行多维分析、钻取溯源和推理演绎，全面实时地展示可信的工厂经营状况，为监管和征信机构提供准确、可信的判断结果。',
        },

    },



    message: {
        part1: {
            tit: '新闻资讯',
            text: '链接最新区块链行业动态'
        },
        part2: {
            time: '发布时间：'
        }
    },



    aboutUs: {
        part1: {
            span11: '持之以',
            span12: '恒',
            span21: '事在人',
            span22: '为',
        },
        part2: {
            tit: '公司简介',
            text1: '江苏恒为信息科技有限公司（以下称为“恒为信息科技”）是由海外归国人才创建的一家专注于区块链底层研发及应用的企业，公司成立于2015年。恒为信息科技依托于区块链技术，拥有自主研发的区块链核心底层技术及区块链应用子公司，规划覆盖完整的区块链生态，包括区块链底层技术研发和应用服务等。恒为信息科技为政府及大型企业集团提供智慧城市、公共服务应用、物联网应用提供技术支持以及区块链服务。恒为自主知识产权区块链及“Co-Chain 多链协同”技术，在可扩展性、并发数、响应延迟等技术指标均达到国际一线水平，其智能合约、原子跨链的实现领先于国内竞争对手，目前正在攻关全球区块链研发最前沿的IPFS存储、分层分片的方向，继续保持技术领先态势。',
            text21: ' 国家互联网信息办公室关于发布第二批境内区块链信息服务备案编号的公告，恒为信息科技自主研发“恒为链”成功备案',
            text22: ' （苏网信备 32021419481366870014 号）',
            text23: '。',
            text3: '为适应区块链发展全球化的特点，恒为信息科技从成立之初起就定位为一家拥有国内自主研发技术的国际化的公司，已在加拿大、新加坡进行布局并拓展行业资源，截止2019年上半年，公司拥有海外独立营运机构或合作机构5家，与全球芯片IP巨头ARM 公司、上海张江高科园区、强生中国、吉利汽车、新希望集团等结成长期战略合作关系。',
        },
        part3: {
            tit: '公司荣誉',
        },
        part4: {
            tit: '联系我们',
            add: '无锡市新吴区菱湖大道111号天鹅座D栋19层',
            email1: '技术合作',
            email2: '商务洽谈',
            email3: '战略部署',
            ewm: '公众号二维码',
        },
        part6: {
            tit: '恒为信息科技',
            text1: '恒为信息科技拥有完全自主知识产权的高性能区块链底层平台“恒为链”，相关区块链发明专利、软著等40多个，国家区块链信息服务备案项目19个、完成华为云服务、国产申威处理器、国产统信操作系统等国产化信创适配。具备高并发、低延迟及强安全特性，支持多链部署与跨链互通。',
            text2: '依托于独立自主研发的“城市链网”区块链底层基础设施建设技术，恒为信息科技在政务、医疗、民生、智慧农业、工业互联网、供应链、数字经济、创新金融、金融监管等多个领域成功落地了30余个应用案例，有效解决数据孤岛与信任难题。通过深度融合人工智能与大数据技术，恒为链持续优化智能合约执行效率，为企业数字化转型提供坚实可信的基础设施支撑，助力构建开放共赢的区块链产业生态体系。',
        },
        part5: {
            tit: '恒为大事记',
            year15: '2015年',
            year16: '2016年',
            year17: '2017年',
            year18: '2018年',
            year19: '2019年',
            y17: {
                data1: '2017/5/1  ',
                event1: '成立物联网+区块链联合实验室并发布行动计划。',
                data2: '2017/8/1',
                event2: '发布《中国区块链与物联网融合创新应用蓝皮书》。',
                data3: '2017/12/1 ',
                event3: '通过中国电子标准化研究院区块链系统技术测评。',
                data4: '2017年底 ',
                event4: '《中国区块链与物联网融合创新应用蓝皮书》的发布荣获“2017年度无锡市软件和信息服务业（企业）”十大最具影响力事件。',
            },
            y18: {
                data1: '2018/6/1  ',
                event1: '发起成立中加物联网与区块链产业发展研究院（无锡分院）。',
                data2: '2018/8/1',
                event2: '中加物联网与区块链产业发展研究院（无锡分院）揭牌成立。',
                data3: '2018/9/1',
                event3: '承办2018世界物联网大会区块链与物联网融合发展峰会。',
            },
            y19: {
                data1: '2019/4/1  ',
                event1: '启动国内首部物联网与区块链融合地方标准的编制。',
                data2: '2019/8/1 ',
                event2: '成为中国区块链技术和产业发展论坛理事成员。',
                data3: '2019/10/18',
                event3: '“恒为链”成功通过境内区块链信息服务服务备案。',
            }
        }
    },
    hwtool: {
        part1: {
            tit1: '恒为数字资产工具包',
            tit2: '安全便捷的加密数字资产管理工具',
            down: '下载',
            ewm: '扫描二维码下载',
            hwtool: 'HWTool',
        },
        part2: {
            tit: '工具特点',
            title1: '安全',
            text1: '密钥本地存储，交易离线签名更安全',
            title2: '简单',
            text2: '操作简单，轻松实现成数字资产的转移和交易',
            title3: '快捷',
            text3: '资产转账速度快，仅需3-5秒就能到账',
        }
    },


    common: {
        footer1: '江苏恒为信息科技有限公司  ',
        footer2: ' 苏ICP备16008019号-1',
        loadMore: '加载更多',
        // download: '下载',
        // timeOut: '请求超时,请重试',
    },

    /*******以下手机端内容******/
    m_menu: {
        home: '首页',
        service: '产品与服务 ',
        product: '产品服务介绍',
        products: '资产管理工具',
        solution: ' 解决方案',
        news: '新闻资讯',
        developers: '开发者平台',
        browser: '区块浏览器',
        aboutus: '关于我们',
        lang: '中/EN'
    },
    m_home: {
        banner: {
            tit1: '恒为信息科技',
            desc1: '专注于区块链技术开发与产品创新',
            tit2: '恒为信息科技',
            desc2: '提供专业的行业区块链整体解决方案',
            tit3: '恒为区块链',
            desc3: '为应用提供高效稳定的区块链服务',
        },
        part2: {
            tit1: '恒为链',
            desc1: '恒为链提供专业、丰富的区块链功能',
            tit2: '资产数字化',
            desc2: '支持NFToken的发行，实现不同类型资产的数字化。',
            tit3: '数据上链',
            desc3: '不仅支持文字的上链，还融合IPFS实现文件的上链存储。',
            tit4: '智能合约',
            desc4: '合约编写、部署、执行简单，执行过程可跟踪。',
            tit5: '跨链服务',
            desc5: '实现恒为链与其他区块链之间价值和信息的互通。',
        },
        part3: {
            tit1: '服务内容',
            desc1: '提供从方案咨询到应用搭建的全套服务',
            tit2: '解决方案',
            desc2: '为企业提供从方案咨询到应用搭建落地的整套行业解决方案。',
            tit3: '区块链服务',
            desc3: '为有上链需求的用户提供低门槛、低成本的区块链服务。',
            tit4: '开发者支持',
            desc4: '为开发者提供开发区块链应用所需的基础设施和文档帮助。',
        },
        part4: {
            tit1: '解决方案',
            desc1: '我们拥有丰富的行业区块链应用落地经验',
            tit2: '供应链金融',
            desc2: '利用区块链公开透明、不可篡改，通证可流通的特点服务于供应链金融。',
            btn: '查看解决方案',
            tit3: '防伪溯源',
            desc3: '利用区块链交易透明、可追溯、不可篡改的特点，实现对商品的防伪溯源。',
            tit4: '物联网',
            desc4: '利用恒为链高并发和支持文件上链的特点，实现物联网设备的数据上链。',
            tit5: '医疗',
            desc5: '利用恒为链并发高、确认快、稳定性好的特点支持医疗行业的区块链应用。',
        },
        part5: {
            tit1: '合作伙伴'
        }
    },
    m_service: {
        part1: {
            tit: '恒为区块链',
            desc: '自主研发的先进可控区块链平台'
        },
        part2: {
            tit1: '技术特点',
            desc1: '具有优越性能的区块链平台',
            tit2: '高性能',
            desc2: '自主研发的HCP共识算法性能达到5000+TPS。',
            tit3: '安全',
            desc3: '非对称加密算法和多种安全机制确保资产和交易安全。',
            tit4: '稳定',
            desc4: '节点监测系统和容错机制保障恒为链服务稳定。',
            tit5: '可扩展',
            desc5: '模块化设计实现加密算法和各类功能的模块化配置。',
        },
        part3: {
            tit1: '核心底层平台',
            desc1: '自主研发的先进可控区块链底层平台',
            tit2: '共识机制',
            desc2: '基于PBFT自主研发的HCP共识算法，性能较高。',
            tit3: '加密算法',
            desc3: '支持国际标准/国密SM2标准椭圆曲线加密算法。',
            tit4: '智能合约',
            desc4: '采用LUA虚拟机，高效易用，合约执行日志可查询。',
            tit5: '数据上链',
            desc5: '根据数据规模，提供文字和IPFS两种数据上链方案。',
            tit6: '资产数字化',
            desc6: '根据ERC721标准，实现NFToken非同质化数字资产。',
            tit7: '批量转账',
            desc7: '支持原子级的单账号高效批量转账功能。',
            tit8: '去中心化交易',
            desc8: '支持恒为链通证间的去中心化撮合交易。',
            tit9: '跨链服务',
            desc9: '实现恒为链与其它区块链之间价值与信息的高效互通。',
        },
        part4: {
            tit1: '赋能服务平台',
            desc1: '为应用接入提供全面的区块链服务平台',
            tit2: 'API',
            desc2: '丰富的API能够方便地与应用系统对接，提供区块链基础服务。',
            tit3: '资产数字化平台',
            desc3: '便捷地发行Token和NFToken，服务于有资产数字化需求的应用。',
            tit4: '区块链浏览器',
            desc4: '恒为链账本信息查询工具，为恒为链上的应用提供交易验证的平台。',
            tit5: '运维管理平台',
            desc5: '实时监测恒为链节点的运行状态，保障恒为链能够提供稳定的服务。',
        },
        part5: {
            tit1: '节点运行状态',
            tit2: '服务上线时间',
            btn: '查看运行状态',
            lb1: '服务已运行',
            lb2: '节点数量',
            lb3: '区块高度',
            lb4: '交易总量',
            days: '天'
        }
    },
    m_solution: {
        hard: {
            tit: '区块链解决方案供应商',
            desc: '提供方案咨询到应用搭建落地的整套行业解决方案'
        },
        center: {
            show1: '资产数字化',
            show2: '防伪溯源',
            show3: '数据共享',
            show4: '可信存证',
            tit1: '方案简介',
            tit2: '应用案例',
            partner: '合作方',
            time: '上线时间',
            tit3: '产品简介',
            tit4: '产品界面',
        },
        part1: {
            text1: '经过数字化的资产，可拆分后进行交易，降低了资产交易的门槛和复杂度，提高了资产的流动性和交易效率。资产交易的过程也是资产在链上流转存证的过程，公开透明的流转记录和可信的存证记录，能够有效地避免资产交易过程中垄断和虚假交易的现象。',
            label: '物博通',
            partner: '2018世界物联网博览会',
            time: '2018年9月',
            text2: '物博通是以2018世界物联网博览会为背景，通过区块链来记录展商与观众间互动，传递价值的小程序。程序主要实现了展商和观众的名片互换、礼品兑换和大会推广等功能。通过区块链，展商以公开透明的方式来获取观众的名片信息和发放礼品。观众以名片互换的方式来获取积分和兑换礼品。展商和观众之间的互动完全透明，避免了活动奖品摆设、内定中奖的现象。',
        },
        part2: {
            text1: '基于区块链数据不可篡改和可追溯的特性，将商品从原料到成品，从生产到流通的各个状态和作业环节上链。一物一码，实现终端消费者对商品的全链条溯源，追溯问题商品的源头，真正做到有责可追，追责有据。结合物联网还可实现信息的自动上链，节省人力，数据更具公信力。',
            label: '呈信农产品溯源平台',
            partner: '呈信区块链科技（云南）有限责任公司',
            time: '2019年6月',
            text2: '呈信农产品溯源平台旨在建立优质农产品溯源体系，帮助地方优质农产品品牌提档升级。平台利用区块链技术信息透明，不可篡改的特点，结合物联网技术，将农业产业的种植养殖、种苗肥料、环境监控、生产日记、采摘甄选、包装物流、销售渠道、原产地追溯等相关信息记录在链上，提升企业质量安全可信度，降低消费者维权监管成本和难度。',
        },
        part3: {
            text1: '通过区块链技术可追溯和不可篡改的特点实现数据的访问授权上链，能够有效解决数据在跨机构多部门间共享过程中的数据确权、数据共享权限控制、共享数据防篡改和数据使用监管方面的问题。区块链可信数据交换环境的建立，大大提高了数据的安全性和数据共享交换的效率。',
            label: '基于区块链的政务数据共享平台',
            partner: '无锡市新吴区科信局',
            time: '2017年11月',
            text2: '无锡市新吴区各政府部门间独立的数据限制了各政府部门服务能力的提升，政务数据的共享又存在着诸多法律、监管、隐私和安全方面的问题。通过区块链技术实现各部门间的数据交换，各部门既是数据的提供方，也是数据的需求方，通过区块链实现数据的授权访问，能够高效实现数据所属权的认定，使用权的监管，正确性和安全性的保障，大大提高了政府数据的利用率，让数据发挥出更大的价值。',
        },
        part4: {
            text1: '基于区块链数据不可篡改，多方参与共识的特性，可被用于电子存证领域。经过多方存证的信息，数据安全、防篡改、永久保存、可信度强，无需第三方机构出具证明，可被视为直接的证据。恒为区块链集成IPFS实现了文件的上链，扩展了存证的种类，文件的 IPFS Hash 被记录在恒为链上无法篡改。',
            label: '智能工厂大数据平台',
            partner: '上海新增鼎数据科技有限公司',
            time: '2018年8月',
            text2: '新增鼎数据利用物联网设备实现工厂无关化的数据采集。基于大数据与人工智能技术进行数据计算、数据建模、行业AI分析，通过区块链技术实现核心数据计算结果的多方存证，利用可视化技术和工具进行多维分析、钻取溯源和推理演绎，全面实时地展示可信的工厂经营状况，为监管和征信机构提供准确、可信的判断结果。',
        },

    },
    m_newslist: {
        tit: '新闻资讯',
        desc: '链接最新区块链行业动态',
        time: '发布时间：',
        more: '加载更多',
        nomore: '没有更多了'
    },
    m_aboutus: {
        part1: {
            p1: '持之以',
            p11: '恒',
            p2: '事在人',
            p22: '为',
            p1_en: '',
            p2_en: '',
        },
        part2: {
            tit: '公司简介',
            p1: '江苏恒为信息科技有限公司（以下称为“恒为信息科技”）是由海外归国人才创建的一家专注于区块链底层研发及应用的企业，公司成立于2015年。恒为信息科技依托于区块链技术，拥有自主研发的区块链核心底层技术及区块链应用子公司，规划覆盖完整的区块链生态，包括区块链底层技术研发和应用服务等。恒为信息科技为政府及大型企业集团提供智慧城市、公共服务应用、物联网应用提供技术支持以及区块链服务。恒为自主知识产权区块链及“Co-Chain 多链协同”技术，在可扩展性、并发数、响应延迟等技术指标均达到国际一线水平，其智能合约、原子跨链的实现领先于国内竞争对手，目前正在攻关全球区块链研发最前沿的IPFS存储、分层分片的方向，继续保持技术领先态势。',
            p21: ' 国家互联网信息办公室关于发布第二批境内区块链信息服务备案编号的公告，恒为信息科技自主研发“恒为链”成功备案',
            p22: '（苏网信备 32021419481366870014 号）',
            p23: '。',
            p3: "目前，恒为信息科技基于区块链的非对称加密、P2P通信协议、共识算法、智能合约以及分布式帐本等底层核心技术在帐户安全、信息互通、价值流通等下一代信息安全等领域都有独到的前瞻性研发部署。"
        },
        part3: {
            tit: '公司荣誉'
        },
        part4: {
            tit: '联系我们',
            p1: '无锡市新吴区菱湖大道111号天鹅座D栋19层',
            p2: '0510-85386599',
            p3: '技术合作 - service@hwelltech.com',
            p4: '商务洽谈 - marketing@hwelltech.com',
            p5: '战略布署 - blockchain@hwelltech.com',
            p6: '公众号二维码'
        },
        part6: {
            tit: '恒为信息科技',
            text1: '恒为信息科技拥有完全自主知识产权的高性能区块链底层平台“恒为链”，相关区块链发明专利、软著等40多个，国家区块链信息服务备案项目19个、完成华为云服务、国产申威处理器、国产统信操作系统等国产化信创适配。具备高并发、低延迟及强安全特性，支持多链部署与跨链互通。',
            text2: '依托于独立自主研发的“城市链网”区块链底层基础设施建设技术，恒为信息科技在政务、医疗、民生、智慧农业、工业互联网、供应链、数字经济、创新金融、金融监管等多个领域成功落地了30余个应用案例，有效解决数据孤岛与信任难题。通过深度融合人工智能与大数据技术，恒为链持续优化智能合约执行效率，为企业数字化转型提供坚实可信的基础设施支撑，助力构建开放共赢的区块链产业生态体系。',
        },
        part5: {
            tit: '恒为大事记',
            year15: '2015年',
            year16: '2016年',
            year17: '2017年',
            year18: '2018年',
            year19: '2019年',
            y17: {
                data1: '2017/5/1  ',
                event1: '成立物联网+区块链联合实验室并发布行动计划。',
                data2: '2017/8/1',
                event2: '发布《中国区块链与物联网融合创新应用蓝皮书》。',
                data3: '2017/12/1  ',
                event3: '通过中国电子标准化研究院区块链系统技术测评。',
                data4: '2017年底 ',
                event4: '《中国区块链与物联网融合创新应用蓝皮书》的发布荣获“2017年度无锡市软件和信息服务业（企业）”十大最具影响力事件。',
            },
            y18: {
                data1: '2018/6/1  ',
                event1: '发起成立中加物联网与区块链产业发展研究院（无锡分院）。',
                data2: '2018/8/1',
                event2: '中加物联网与区块链产业发展研究院（无锡分院）揭牌成立。',
                data3: '2018/9/1',
                event3: '承办2018世界物联网大会区块链与物联网融合发展峰会。',
            },
            y19: {
                data1: '2019/4/1 ',
                event1: '启动国内首部物联网与区块链融合地方标准的编制。',
                data2: '2019/8/1',
                event2: '成为中国区块链技术和产业发展论坛理事成员。',
                data3: '2019/10/18',
                event3: '“恒为链”成功通过境内区块链信息服务服务备案。',
            }
        }
    },
    m_foot: {
        desc1: 'CopyRight © 2015~2020 江苏恒为信息科技有限公司  ',
        desc2: ' 苏ICP备16008019号-1'
    },
    m_hwtool: {
        part1: {
            tit1: '恒为数字资产工具包',
            tit2: '安全便捷的加密数字资产管理工具',
            down: '下载',

        },
        part2: {
            tit: '工具特点',
            title1: '安全',
            text1: '密钥本地存储，交易离线签名更安全',
            title2: '简单',
            text2: '操作简单，轻松实现成数字资产的转移和交易',
            title3: '快捷',
            text3: '资产转账速度快，仅需3-5秒就能到账',
        }
    },
}

export default cn